import React from 'react';
import { IContent } from '../../../types';
import { CategoryDealItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './CategoryDealElement.scss';
import { getShopURL, sendEvent } from '../../../utils';
import BackgroundImageElement from "../../UI/Image/BackgroundImageElement";

// @ts-ignore
import Fade from 'react-reveal/Fade';

interface ICategoryDealElementProps {
  context?: IContent;
  category: CategoryDealItem;
  index: number;
}

const CategoryDealElement = ({ category, index }: ICategoryDealElementProps) => {
  const { title, tracking, link } = category;
  return (
    <Fade delay={100 * index} duration={600}>
      <div className="block-category_deal">
        <a
          href={getShopURL() + link}
          onClick={() => sendEvent(tracking)}
        >
          <BackgroundImageElement
            classNames={["bg-image"]}
            tag={"span"}
            imageName={`bg-category_deal${index}.jpg`}
          />
          <span className="content" dangerouslySetInnerHTML={{ __html: title }} />
        </a>
      </div>
    </Fade>
  );
};

export default withContent(CategoryDealElement);
